import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSecurePayment = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 11" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={4} height={6} x={2.5} y={0.5} stroke="#52B33E" rx={2} />
      <rect
        width={8}
        height={7}
        x={0.5}
        y={3.5}
        fill="#FFF"
        stroke="#15B323"
        rx={1}
      />
      <path fill="#15B323" d="M4 6h1v3H4z" />
    </g>
  </svg>
);
const Memo = memo(SvgSecurePayment);
export default Memo;
